import { render, staticRenderFns } from "./ProfileFans.vue?vue&type=template&id=b4ad142e&scoped=true&"
import script from "./ProfileFans.vue?vue&type=script&lang=js&"
export * from "./ProfileFans.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFans.vue?vue&type=style&index=0&id=b4ad142e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ad142e",
  null
  
)

export default component.exports